/**
 * טוקן יעד/מוצא ל־POST /searchFlights — מחרוזת (קוד שדה או שם עיר),
 * כפי ש־get_search_lds_flights_payload שולח ל־LDS ב־depOrigCities / depDestCities.
 */

export function primaryLocation(loc) {
  if (Array.isArray(loc) && loc.length > 0) return loc[0];
  return loc;
}

/**
 * @param {unknown} loc
 * @returns {string|undefined}
 */
export function resolveFlightEndpointToken(loc) {
  if (loc == null) return undefined;
  if (typeof loc === "string") {
    const t = loc.trim();
    return t || undefined;
  }
  const o = Array.isArray(loc) ? loc[0] : loc;
  if (!o || typeof o !== "object") return undefined;
  const code =
    o.AIRPORTCODE ??
    o.IATACODE ??
    o.iata ??
    o.airportCode ??
    o.code ??
    o.Code ??
    o.CODE ??
    o.value;
  if (code != null && String(code).trim() !== "") {
    return String(code).trim();
  }
  const city =
    o.CITYNAME ??
    o.cityName ??
    o.depCity ??
    o.arrCity ??
    o.CITY ??
    o.name;
  if (city != null && String(city).trim() !== "") {
    return String(city).trim();
  }
  return undefined;
}

export function resolveOriginTokenForSearchFlights(origin) {
  const t = resolveFlightEndpointToken(origin);
  if (t) return t;
  if (origin?.AIRPORTCODE != null && String(origin.AIRPORTCODE).trim() !== "") {
    return String(origin.AIRPORTCODE).trim();
  }
  return "TLV";
}

export function resolveDestinationTokenForSearchFlights(location) {
  const primary = primaryLocation(location);
  return (
    resolveFlightEndpointToken(primary) ||
    resolveFlightEndpointToken(location) ||
    undefined
  );
}

export function resolveRetEndpointToken(primary, raw) {
  if (!primary && !raw) return undefined;
  const t =
    resolveFlightEndpointToken(primary) ||
    (raw?.AIRPORTCODE != null && String(raw.AIRPORTCODE).trim() !== ""
      ? String(raw.AIRPORTCODE).trim()
      : undefined) ||
    resolveFlightEndpointToken(raw);
  return t || undefined;
}
